export function getNewTrip({ carrier, sequence }) {
    return {
        name: '',
        legs: [
            getEmptyLeg({
                carrier: carrier,
                sequence,
            }),
        ],
    };
}
export function getEmptyLeg({ carrier, sequence }) {
    const orderCarrier = carrier || {};
    return {
        carrier: orderCarrier.name || '',
        carrier_id: orderCarrier._id,
        sequence,
        shipment_type: 'drayage',
        status: '',
        stops: [
            {
                sequence: 1,
                equipments: [],
                action: 'pickup',
                empty: false,
                location: {
                    name: '',
                    address: '',
                },
            },
            {
                sequence: 2,
                equipments: [],
                action: 'deliver',
                empty: false,
                location: {
                    name: '',
                    address: '',
                },
            },
            {
                sequence: 3,
                equipments: [],
                action: 'deliver',
                empty: true,
                location: {
                    name: '',
                    address: '',
                },
            },
        ],
    };
}
export function convertShipmentsToTrip(shipments) {
    const legs = shipments.map((shipment) => {
        const { shipment_type, carrier, } = shipment;
        const stops = shipment.stops.map((stop) => {
            let location;
            const { action, empty, equipments, } = stop;
            if (shipment.status === 'Staging') {
                const { location: { name, address, }, } = stop;
                location = {
                    name,
                    address,
                };
            }
            else {
                const stopLocation = stop.location[0] || { name: '', address: '' };
                const { name, address, } = stopLocation;
                location = {
                    name,
                    address,
                };
            }
            return {
                action,
                empty,
                location,
                equipments,
            };
        });
        return {
            shipment_type,
            carrier,
            stops,
        };
    });
    return {
        legs,
        name: '',
    };
}
